import React, { useRef, useEffect } from "react";

const testimonials = [
  {
    text: "Synergy Innovation Enterprises has been an exceptional export partner. Their professionalism, product quality, and timely deliveries have helped us scale our business with confidence.",
    author: "Anita Mehta, Import Manager, UK",
  },
  {
    text: "Reliable, efficient, and always responsive—Synergy Innovation Enterprises understands global business. We've been sourcing from them for over a year and the consistency is remarkable.",
    author: "Daniel Lee, Wholesale Trader, Singapore",
  },
  {
    text: "From packaging to paperwork, everything was handled smoothly. Their dedication to quality and service is truly commendable.",
    author: "Ahmed Al-Farsi, Food Importer, UAE",
  },
  {
    text: "Synergy Innovation Enterprises is more than a supplier—they’re a strategic partner. They helped us understand the Indian market better and source premium products at competitive rates.",
    author: "Marta Rodrigues, Procurement Head, Brazil",
  },
  // {
  //   text: "Absolutely stunning craftsmanship! I’ll be buying more as gifts for my family.",
  //   author: "Priya Singh",
  // },
];

export default function Testimonials() {
  const scrollRef = useRef(null);

  useEffect(() => {
    const container = scrollRef.current;
    let scrollAmount = 0;

    const scrollInterval = setInterval(() => {
      if (container) {
        scrollAmount += 1;
        container.scrollLeft += 1;

        if (scrollAmount >= container.scrollWidth - container.clientWidth) {
          scrollAmount = 0;
          container.scrollLeft = 0;
        }
      }
    }, 20);

    return () => clearInterval(scrollInterval);
  }, []);

  return (
    <section className="py-10 bg-white border-t border-b">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-extrabold text-[#4b2e19] text-center mb-4 drop-shadow-sm">
          TESTIMONIALS
        </h2>
        <p className="text-center text-gray-700 mb-8 tracking-wide font-medium uppercase">
          GREAT WORD FROM OUR CLIENTS
        </p>

        <div
          ref={scrollRef}
          className="overflow-x-auto scroll-smooth flex gap-6 px-2 md:px-4 no-scrollbar"
        >
          {testimonials.map((item, index) => (
            <div
              key={index}
              className="relative flex-shrink-0 w-[80vw] sm:w-[350px] md:w-[380px] rounded-2xl shadow-md border overflow-hidden"
            >
              {/* Top Quotation Mark */}
              <div className="absolute top-2 left-2 text-4xl text-[#9c6027]">❝</div>

              {/* Card Body */}
              <div className="bg-gradient-to-br from-[#A05E2A] to-[#DDB395] text-white p-6 h-[300px] sm:h-[270px] flex flex-col justify-center rounded-t-2xl">
                <p className="text-sm leading-relaxed break-words whitespace-pre-line">
                  {item.text}
                </p>
              </div>

              {/* Bottom section */}
              <div className="bg-white p-4 rounded-b-2xl flex flex-col items-center">
                <div className="w-14 h-14 bg-gradient-to-br from-[#9c6027] to-[#c48c5c] rounded-full -mt-8 flex items-center justify-center">
                  <div className="w-10 h-10 bg-white rounded-full" />
                </div>

                <div className="text-yellow-400 text-lg mt-2">
                  {[...Array(5)].map((_, i) => (
                    <span key={i}>★</span>
                  ))}
                </div>

                <p className="mt-2 text-sm font-semibold text-center text-[#9c6027]">
                  {item.author}
                </p>
              </div>

              {/* Bottom Quotation Mark */}
              <div className="absolute bottom-2 right-2 text-4xl text-[#9c6027]">❞</div>
            </div>
          ))}
        </div>
      </div>

      {/* Hide scrollbar via custom class */}
      <style jsx>{`
        .no-scrollbar {
          -ms-overflow-style: none; /* IE and Edge */
          scrollbar-width: none; /* Firefox */
        }
        .no-scrollbar::-webkit-scrollbar {
          display: none; /* Chrome, Safari, Opera */
        }
      `}</style>
    </section>
  );
}
